
import useAccount from '@/common/composable/useAccount'
import { defineComponent, onMounted } from 'vue'

const TABS = [
    { id: 'general', name: 'О компании' },
    { id: 'chat', name: 'История взаимодействий' },
    { id: 'settings', name: 'Настройки компании' },
]

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()

        const isTabSelected = (tab: { id: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const selectTab = (tab: { id: string }) => {
            if (isTabSelected(tab)) return
            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        onMounted(() => {
            const settingsTab = TABS.find((tab) => tab.id === 'settings')

            if (!settingsTab && havePermissions(['company.settings-index'])) {
                TABS.push({ id: 'settings', name: 'Настройки компании' })
            }
        })

        return {
            TABS,
            isTabSelected,
            selectTab,
        }
    },
})
